import React from 'react';

function HighscoreModal({ onClose }) {
  return (
    <div className="absolute top-0 left-0 w-full h-full bg-black/50 flex items-center justify-center">
      <div className="bg-gradient-to-b from-[#057CC1] to-[#025F94] p-6 rounded-lg shadow-lg w-3/4 max-w-md relative">
        <h2 className="text-white text-lg font-bold mb-4">Highscores</h2>
        <p className="text-white mb-4">Highscore feature will be added in a future update.</p>
        <img
          src="/closeBtn.png"
          alt="Close"
          onClick={onClose}
          className="absolute -top-5 -right-5 w-10 h-10 cursor-pointer hover:opacity-80 transition-opacity duration-300 animate-wobble"
        />
      </div>
    </div>
  );
}

export default HighscoreModal;